"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const stickyContainerInputs = [
  {
    name: "position",
    type: "string",
    enum: ["bottom", "top"],
    required: true,
    defaultValue: "bottom",
  },
] as const satisfies Inputs;

const StickyContainer = dynamic(
  async () =>
    withValidation(stickyContainerInputs, (await import("./StickyContainer")).StickyContainer, "StickyContainer"),
  {
    ssr: false,
  }
);

export const StickyContainerComponent: RegisteredComponent = {
  name: "StickyContainer",
  component: StickyContainer,
  inputs: stickyContainerInputs,
  canHaveChildren: true,
};
